export default {"src":"/_next/static/media/icon_location1.6c3b95c1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};